import React, {useState, useEffect} from 'react'
import { ShareContainer, RegistContainer, FormCotainer, RegistModalContent,IconClose,FlexBox} from './style'
import { Ctitle} from './../components/style'
import OpenApp from '../../../components/OpenApp';

import {  InputItem , Toast, Modal} from 'antd-mobile';
import h5Share from '@/utils/h5Share'
import { sendMessage, registerInvite, getInvitationUserInfo } from '@/api/user-new'
import Explain from '../components/explain';
import TimeBlock from '../components/TimeBlock'
import Rank from '../components/rank'
import { rsaString } from '@/utils'
// import { jumpTo } from '@/utils'

const regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
const SharePullRegist = ({props}) => {
  const [userInfo, setUsename] = useState({})
  const [value, setvalue] = useState('')
  const [code, setcode] = useState('')
  const [inviteCode, setinviteCode] = useState('')
  const [visible, setvisible] = useState(false)
  const [hasphone, setHasphone] = useState(false)
  const [type, setType] = useState('1')
  let [count, setCount] = useState(60)
  const [ status, setStatus ] = useState('t1')
  const activityId = 50;
  const getCode = () => {
    const val = value.replace(/\s*/g,"")
    if(!regPhone.test(val)){
      Toast.info('请输入正确手机号');
    } else {
      // verifyPhone({C_PHONE: rsaString(val)}).then(res=> {
      //   if(res.resultCode === '00'){
          setType('1')
          // setvisible(false)
          sendMessage({PHONE:rsaString(val), type: '9'}).then(res=>{
            if(res.resultCode === '00'){
              setHasphone(true)
              let timer = null
              clearInterval(timer)
              timer = setInterval(()=>{
                if(count === 0) {
                  clearInterval(timer)
                  setCount(60)
                  setHasphone(false)
                } else {
                  setCount(count--)
                }
              }, 1000)
            }
          })
        // } else if(res.resultCode === '01') {
        //   setType('2')
        //   setvisible(true)
        // } else if(res.resultCode === '01'){
        //   Toast.info('请输入正确手机号')
        // }
      // })
    }
  }
  const regist = () => {
    const val = value.replace(/\s*/g,"")
    if(regPhone.test(val)){
      const params ={
        phone: val, 
        smsCode: code,
        activityId: activityId, // 会员邀请活动 ，前端写死
        inviteCode: inviteCode
      }
      registerInvite(params).then(res=>{
        setvisible(true)
        setType('1')
        // if(res.resultCode === '00'){
        //   setvisible(true)
        //   setType('1')
        // } else {
        //   Toast.info(res.resultMsg);
        // }
      })
      .catch(err => {
        const message  = err.response.data.errors[0].message

        Toast.info(message);
      })
    } else {
      Toast.info('请输入正确手机号')
    }
  }
  const openlink = () => {
    setvisible(false)
    window.location.href="https://filetest.wogoo.com/app/download/index.html"
  }
  const tabs = [
    {
      key: 't1',
      value: '大赛奖励'
    },
    {
      key: 't2',
      value: '大赛排行'
    },
    // {
    //   key: 't3',
    //   value: '我的邀请'
    // }
  ]
  const changeValue = val => {
    setcode(val)
  }
  const onChangePhone = val =>{
    setvalue(val)
  }
  const initPage = () => {
    let data = {}
    setinviteCode(props.match.params.code)
    
    getInvitationUserInfo({invitedCode: props.match.params.code}).then(res=>{

      if(res){
        setUsename(res)
         data = { 
          // title:  `@${res}喊您一起来用市值风云APP了`, 
          title: `${res.nickname}邀请您来参与组合炒股大赛，赢取万元大奖！`,
          desc: '华为Mate60Pro、小米14、300元京东卡…..13次赢取大奖机会！', 
          link: window.location.href,
          imgUrl:  'https://file.wogoo.com/app/logo/logo6.png',
          wxShare:{
            shareData:{
              imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
            }
          },
          shareData:{
            imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
          }
        }
        h5Share.main(data)
      } else {
        setUsename('')
        data = {
          title: `${res.nickname}邀请您来参与组合炒股大赛，赢取万元大奖！`,
          desc: '华为Mate60Pro、小米14、300元京东卡…..13次赢取大奖机会！',
          link: window.location.href,
          imgUrl:  'https://file.wogoo.com/app/logo/logo6.png',
          wxShare:{
            shareData:{
              imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
            }
          }
        }
        h5Share.main(data)
      }
      
   }).catch(err => {
     console.log(err);
   })
  }

  useEffect(() => {
    initPage()
    document.title = '参赛赢大奖，入金得现金'
    // document.body.style = "background-color:#F23F56!important;"
  }, [])
 
  return (
    <ShareContainer>    
      <OpenApp ></OpenApp>
      <div className='user_box'>
      {/* <img className="header" src='http://localhost:3000/assets/img/actvity22/bg1.jpg' alt="市值风云" /> */}
      <div>
        <img className='avatar' src={userInfo.avatar} alt="" />
      </div>
      <div className='nickname'>{userInfo.nickname}</div>

      <div>
        <div className='tip'>邀请您参加炒股大赛，赢取万元大奖！</div>
        </div>
      </div>
      <img className="header" src={require('@/img/activity50/bg1.png')} alt="市值风云" />
  
      <RegistContainer >
        <div className={'container'}>
   
          <FormCotainer>
            <div className={'form-item'} > 
              <InputItem type="phone" defaultValue={value}   editable  clear onChange={(val)=>onChangePhone(val)}>+86</InputItem>
            </div> 
             <div className={'form-item'}>
              <InputItem type="number" className={'text'} defaultValue={code} editable  clear maxLength={4} placeholder={'请输入验证码'} onChange={(val)=>changeValue(val)}/>
              {!hasphone? <div className={'button active'} onClick={()=> getCode()}>获取验证码</div>: 
              <div className={'button'}>{count} 后重新获取 </div>}
            </div>
            <div className={'regist'} onClick={()=>regist()}>
                <img className='header' src={require('@/img/activity22/btn.png')} alt=""></img>
            </div> 
            <div  className={'message'} >注：新用户登录APP即送1天风云VIP权益</div>
          </FormCotainer>
          {/* :<Center><Empty text={'抱歉，邀请信息不正确，无法访问'} imageSrc={ require(`@/img/user-new//pic_zwdw2x.png`)}/></Center>} */}
        </div>
     </RegistContainer>
     
      <Modal
          visible={visible}
          transparent
          className={'regist-modal regist-modal_match'}
          maskClosable={true}
          onClose={()=> setvisible(false)}
          title=""
        >
          <Ctitle style={{top: '-31px'}}><div >提示</div></Ctitle>
          <IconClose onClick={()=> setvisible(false)}/>
          <RegistModalContent>
            <div className={'regist-modal-content-text'}>{type==='1'? <div>恭喜，您已经成功领取到风云VIP权益，<br/> 快前往市值风云APP领取VIP权益并<br/>参与组合大赛赢取万元大奖</div>: <div>您好，该手机号已注册过市值风云，<br/>请打开APP前往【行情】-【组合】<br/>参与组合大赛赢取万元大奖</div>}</div>
              <div className={'regist-modal-content-group'}>
              {type ==='2' &&<div className='regist-modal-button'>
                <div onClick={()=>setvisible(false)} className='modal-button'>关闭</div>
                <div onClick={()=>openlink()} className='modal-button'>打开APP</div>
              </div>}
              
              {type ==='1' &&<div className={'regist-modal-content-button'} onClick={()=>openlink()}>打开APP</div>}
           </div>
          </RegistModalContent>
        </Modal>

      {/*  */}
      <div style={{width:'100%',marginTop:'1vw',}} >

        <TimeBlock startTime={'2023年12月12日'} endTime={'2023年3月8日'} />
       
      </div>
      {/* <img className="member-img" onClick={()=> {
            jumpTo(window.location.origin + '/activity/active_50/sponsor')
          }} style={{marginTop: '0px',width:'100%',padding:'0 3vw 2vw',boxSizing:'border-box'}}  src={require('@/img/activity50/sponsorAds@2x.png')} alt="市值风云" />
       */}
      <div className='sticky'>
        
      <FlexBox className='flex' style={{marginTop:'2vw'}}>
        {
          tabs.map(it => {
            return( <div
              key={it.key} 
              className={  it.key === status? 'flex-item block':'flex-item'  } 
                onClick={()=> {
                  setStatus(it.key)
                }}
            >{it.value}</div>
            )
          })
        }
      </FlexBox>
      </div>

      {/* 活动说明 */}
      

      <div className={ status === 't1' ? 'show':'hidden'}>
        <div className="title-box">
          <div className="title">季赛奖励：万元大奖等你来拿</div>
        </div>

        <img className="member-img" style={{width:'100%',marginTop: '0px',padding: '0 3vw',boxSizing:'border-box'}} src={require('@/img/activity50/1@2x.png')} alt="市值风云" />
        <div className="title-box">
          <div className="title">周赛奖励：12周比赛，周周拿奖</div>
        </div>
        <img className="member-img" style={{width:'100%',marginTop: '0px',padding: '0 3vw',boxSizing:'border-box'}}src={require('@/img/activity50/2@2x.png')} alt="市值风云" />
        <div className="title-box">
          <div className="title">邀请好友奖励，朋友带你拿万元大奖</div>
        </div>
        {/* <div className="message"></div> */}
        <img className="member-img" style={{width:'100%',marginTop: '0px',padding: '0 3vw',boxSizing:'border-box'}}src={require('@/img/activity50/3@2x.png')} alt="市值风云" />
       
        {/* <div style={{height: '30px'}}></div> */}
      </div>

      <div className={ status === 't2' ? 'show':'hidden'}>
          <Rank activityId = {activityId } showBottom={false}/>
        </div>
        <div style={{
          'padding':'10px 0 30px',
          "fontSize": "15px",
          textAlign: "center",
          "color": "#FF909E",
          "lineHeight": '24px'
          }}> 活动一切解释权归市值风云所有 <br/> 投资有风险 入市需谨慎</div>
      <Explain top='-50'/>

    </ShareContainer>
  )
}

export default SharePullRegist


// WEBPACK FOOTER //
// ./src/views/activity_50/share-pull-regist/index.js